module.exports = __webpack_public_path__ + "img/1484330007.8d5946b1.jpg";